import lang from '../langs/lang.json'
import langFaq from '../langs/lang-faq.json'

try {
    const mergedLang = {
        ...langFaq,
        ...lang
    }

    const languageChangeSelect = document.querySelector('#language-change-checkbox');
    const setNewLanguage = (code) => {
        const tags = document.querySelectorAll('[data-langkey]');
        tags.forEach((el) => {
            const {langkey} = el.dataset;
            if (mergedLang[langkey]) el.innerText = mergedLang[langkey][code]
        })
    }
    languageChangeSelect.addEventListener('change', (e) => {
        const lang = e.target.checked ? 'by' : 'ru';
        localStorage.setItem('language', lang)
        setNewLanguage(lang)
    })
    const language = localStorage.getItem('language');
    if (language === 'ru' || language === 'by') {
        languageChangeSelect.checked = language === 'by';
        setNewLanguage(language)
    }
} finally {
    document.body.classList.remove('no-display')
}
